import { action } from 'easy-peasy';
import { ISetExemptionCategoriesAction } from '../types';

const setExemptionCategories: ISetExemptionCategoriesAction = action((state, payload) => {
  state.exemptionCategories = payload;
});

export default setExemptionCategories;
